import { useState, useEffect } from 'react';
import axios from 'axios';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '@/components/ui/sheet';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import LevelHistoryTable from '@/components/motivare/LevelHistoryTable';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export default function LevelHistorySheet({ row, year, month, onClose }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!row) return;
    setData(null);
    axios.get(`${API_URL}/motivare/level-history`, { ...auth(), params: { indicativ: row.indicativ, year, month } })
      .then((r) => setData(r.data)).catch(() => toast.error('Nu s-a putut încărca istoricul Level'));
  }, [row, year, month]);

  return (
    <Sheet open={!!row} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="w-[760px] sm:max-w-[760px] flex flex-col" data-testid="level-history-sheet">
        <SheetHeader>
          <SheetTitle className="text-base">Istoric Level · {row?.indicativ}</SheetTitle>
          <SheetDescription>{row?.name} · toate raportările Level din luna curentă, pe zile{data?.backup ? ' · back-up: Level +1 față de raport' : ''}</SheetDescription>
        </SheetHeader>
        <div className="overflow-y-auto flex-1 mt-3 pr-1">
          {!data ? <div className="flex items-center gap-2 text-sm text-slate-500 py-6"><Loader2 className="w-4 h-4 animate-spin" /> Se încarcă...</div> : <LevelHistoryTable data={data} />}
        </div>
      </SheetContent>
    </Sheet>
  );
}
